import React from "react";
import HcsCaptionControl from "./hcs-captioncontrol";

export default class HcsRadioSelect extends HcsCaptionControl {
	constructor(props) {
		super(props);

		this.valueChanged = this.valueChanged.bind(this);
	}

	valueChanged(attrValue) {
		let self = this;

		const { data } = this.props;

		if(data.info.value !== attrValue) {
			this.props.checkValueChange(this, {
				confirmed: _ => {
					self.props.onConfig("setCfgValue", data.ident, attrValue, {
						sender: "HCS_RADIOSELECT",
						success: _ => {
							super.triggerConfigurator();
						}
					});
				}
			});
		}
	}

	// override from base class
	getCcaoData() {
		const { data } = this.props;

		if( data.info.value !== "" ) {
			let value = data.values.find(value => {
				return value.ident === data.info.value;
			});

			if(value && value.data.CCAO_DATA) {
				try {
					return JSON.parse(value.data.CCAO_DATA);
				} catch(e) {
					console.error(`Error parsing CCAO_DATA object from ECS for attribute '${data.ident}' with value '${data.info.value}': ${e.message}: ${value.data.CCAO_DATA}`);
				}
			}
		}

		return null;
	}

	childClass() {
		return "hcs-radioselect";
	}

	render() {
		const { data } = this.props;

		let radioGroupName = "hcs-radio-grp-" + data.ident;
		let uKey = "hcs-radio-grp-" + data.ident + "-" + data.info.value;

		return super.render(
			data.values.length ?
				<ul key={uKey}>
					{
						data.values.filter(item => item.info.visible).map(function(item, index) {
							let fId = "hcs-radio-" + data.ident + "-" + item.ident;

							let cfgSuggest = null;

							if(item.flags && item.flags.CFGSuggest) {
								cfgSuggest = {};
								cfgSuggest[item.flags.CFGSuggest] = item.flags.CFGSuggest;
							}

							return <React.Fragment key={`hcs-radio-${data.ident}-${index}`}>
								<span className="hcs-break"></span>
								<li key={`hcs-dragitem-${data.ident}-${index}`} {...cfgSuggest}>
									<input
										id={fId}
										name={radioGroupName}
										defaultChecked={item.ident === data.info.value}
										type="radio" />
									<span
										onClick={this.valueChanged.bind(this, item.ident)} />
									<label
										htmlFor={fId}
										onClick={this.valueChanged.bind(this, item.ident)}>{item.info.trans}</label>
								</li>
							</React.Fragment>;
						}, this)
					}
				</ul> : <span className="hsc-radio-no-items">Item does not contain any selection values!</span>
		);
	}
}